import React from 'react';
import { Box, Heading, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { useAccessControl } from '../../hooks/useAccessControl';
import EmployeeBankDetailsComponent from '../payrollsheet/tabs/EmployeeBankDetails';

const EmployeeBankDetails = () => {
  const { canAccessPayroll } = useAccessControl();
  const bgColor = useColorModeValue("white", "gray.800");

  if (!canAccessPayroll()) {
    return (
      <Box p={6} bg={bgColor} borderRadius="lg" shadow="sm">
        <VStack spacing={4} align="center">
          <Heading size="lg" color="red.500">Access Denied</Heading>
          <Text color="gray.600">
            You don't have permission to access employee bank details.
          </Text>
        </VStack>
      </Box>
    );
  }

  return (
    <Box p={6} bg={bgColor} borderRadius="lg" shadow="sm">
      <VStack spacing={6} align="stretch">
        <Box>
          <Heading size="lg" mb={2}>Employee Bank Details</Heading>
          <Text color="gray.600">
            Manage employee banking information and payment details for payroll processing.
          </Text>
        </Box>
        <EmployeeBankDetailsComponent />
      </VStack>
    </Box>
  );
};

export default EmployeeBankDetails;